module.exports = __webpack_public_path__ + "static/media/avatar_default.e5d84eb6.png";